import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'

const PayrollHistory = () => {
    const [payrolls, setPayrolls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPayrolls = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = Cookies.get('token');
                // Using the endpoint provided in the snippet, but checking if it should be relative to API_BASE_URL
                // Since the snippet used a full URL, I will follow that but consider the project's config if it fails.
                const response = await axios.get(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setPayrolls(response.data);
            } catch (err) {
                console.error("Error fetching payrolls:", err);
                setError('Failed to fetch payroll history.');
            } finally {
                setLoading(false);
            }
        };
        fetchPayrolls();
    }, []);

    // Helper to format date as 'Month Year' or 'Day Month Year'
    const formatMonthYear = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    };

    const formatDayMonthYear = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
    };

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
            <Topbar />
            <Sidebar />
            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row mb-4">
                            <div className="col-xl-12">
                                <div className="page-title-box">
                                    <h1 className="page-title fs-24 lh-1 mb-2">Payroll History</h1>
                                    <p className="subtitle text-muted">View all processed payroll cycles</p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-body p-4">
                                        {loading ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-primary mb-3" role="status"></div>
                                                <p className="text-muted fw-medium">Loading payrolls...</p>
                                            </div>
                                        ) : error ? (
                                            <div className="text-center py-5">
                                                <div className="text-danger mb-3 fs-1">{error}</div>
                                                <button className="btn btn-primary" onClick={() => window.location.reload()}>Retry</button>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-hover align-middle mb-0">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th className="px-3 py-3 font-semibold text-dark">Payroll Month</th>
                                                            <th className="px-3 py-3 font-semibold text-dark">Processing Date</th>
                                                            <th className="px-3 py-3 font-semibold text-dark text-center">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {payrolls.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="3" className="text-center py-5 text-muted">No payroll data found.</td>
                                                            </tr>
                                                        ) : (
                                                            payrolls.map((payroll) => (
                                                                <tr key={payroll.id}>
                                                                    <td className="px-3 py-3">
                                                                        <span className="fw-bold text-dark">{formatMonthYear(payroll.month)}</span>
                                                                    </td>
                                                                    <td className="px-3 py-3 text-muted">
                                                                        {formatDayMonthYear(payroll.date_processed || payroll.created_at || payroll.month)}
                                                                    </td>
                                                                    <td className="px-3 py-3 text-center">
                                                                        <button
                                                                            className="btn btn-primary btn-sm px-4 shadow-sm"
                                                                            onClick={() => navigate(`/hr/payroll/${payroll.id}/payslips`)}
                                                                        >
                                                                            View Payslips
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default PayrollHistory